/**
 * The joined room's ids and labels, as the browser can read them right after a join. The room
 * state syncs `customRoomId`, `companyId`, `name` and `description` as top-level fields;
 * `OfficeState.metadata` is server-only and never reaches the browser. An unknown id comes back
 * `undefined`, so `setJoinedRoomData` keeps what `SEND_ROOM_DATA` already stored instead of
 * overwriting it.
 */
export interface JoinedRoomFields {
  customRoomId?: string
  companyId?: string
  name?: string
  description?: string
}

export function joinedRoomFields(roomState: unknown): JoinedRoomFields {
  const s = (roomState ?? {}) as Record<string, any>
  const meta = (s.metadata ?? {}) as Record<string, any>
  const pick = (...values: unknown[]) => values.find((v): v is string => typeof v === 'string' && v !== '')
  return {
    customRoomId: pick(s.customRoomId, meta.customRoomId, meta.customRoomId),
    companyId: pick(s.companyId, meta.companyId),
    name: pick(s.name, meta.name),
    description: pick(s.description, meta.description),
  }
}
